import { NgModule } from '@angular/core'
import { FuzzySearchPipe } from './fuzzy-search.pipe'

@NgModule({
  declarations: [FuzzySearchPipe],
  exports: [FuzzySearchPipe]
})
export class FuzzySearchModule {}
